import { CONFIG_MAP_UPDATE, CONFIG_MAP_GET_MAP_SERVICES, RESET } from '../actions/Events';

export default function (state = { config: {} }, action) {
  switch (action.type) {
    case CONFIG_MAP_UPDATE:
      return { ...state, config: action.payload }

    case CONFIG_MAP_GET_MAP_SERVICES:
      return { ...state, mapServices: action.payload }

    case RESET:
      return { config: {} }

    default:
      return state
  }
}

